import { Col, Row } from 'antd5';
import { Dispatch, SetStateAction } from 'react';
import { AtlasGqlMetadataField, AtlasGqlMetadataFieldMapping } from 'types/atlas-graphql';
import { Steps } from '../UploadInspectionDataModal';
import { ButtonContainer, LabelColumn } from '../UploadInspectionDataModal.style';
import { Button } from 'components/ui';
import { useUploadContext } from 'components/FileUploader';

type PreviewProps = {
  inspectionCount: number;
  internalFields: AtlasGqlMetadataField[];
  fieldMappings: AtlasGqlMetadataFieldMapping[];
  record: { [key: string]: string };
  setStep: Dispatch<SetStateAction<Steps>>;
  handleComplete: () => void;
};

export const Preview: React.FC<PreviewProps> = ({
  inspectionCount,
  internalFields,
  fieldMappings,
  record,
  setStep,
  handleComplete,
}) => {
  const { uploading } = useUploadContext();

  return (
    <>
      <p>
        This will create {inspectionCount} inspection{inspectionCount === 1 ? '' : 's'}.
      </p>
      <p>Preview of the first uploaded inspection:</p>
      {fieldMappings.map(({ sourceFieldName, targetFieldName }) => (
        <Row key={targetFieldName}>
          <Col flex="10%" />
          <LabelColumn flex="auto">
            <label>
              {internalFields.find(field => field.internalName === targetFieldName)?.displayName ??
                targetFieldName}
              :
            </label>
          </LabelColumn>
          <Col flex="60%">{record[sourceFieldName]}</Col>
        </Row>
      ))}
      <ButtonContainer>
        <Button onClick={() => setStep(Steps.SummaryMapping)}>Back</Button>
        <Button type="primary" onClick={handleComplete} loading={uploading}>
          Continue
        </Button>
      </ButtonContainer>
    </>
  );
};
